<template>
  <RevDrawer :name="MODAL_NAMES.NEW_BATTERY" :title="i18n(translations.title)">
    <template #body>
      <StandardVsNew :brand :category-id />
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './NewBatteryModal.translations'
import StandardVsNew from './components/BatteryModalContent/StandardVsNew.vue'

const i18n = useI18n()

withDefaults(
  defineProps<{
    brand: string
    deviceName?: string
    categoryId: string
  }>(),
  {
    brand: '',
    deviceName: '',
  },
)
</script>
